import React from 'react';

import { Grid } from '@material-ui/core';

import { array, bool } from 'prop-types';
import generate from 'shortid';

import { getTarget } from '../../../../libs';

import { ListItem, Link, ListStyled } from './styles';

const FooterHelpAndSupport = ({ helpSupport, isRender, ...others }) => (
  <Grid {...others}>
    <ListStyled>
      {!isRender && (
        <ListItem>
          <Link href="/atendimento/central-de-atendimento-pagamento" title="Tire suas duvidas">
            Precisa de ajuda?
          </Link>
        </ListItem>
      )}
      {isRender &&
        helpSupport &&
        helpSupport.map(
          (elem) =>
            (elem.texto1 || elem.texto2) && (
              <ListItem key={`${elem.texto2}-${generate()}`}>
                <Link href={elem.link} title={elem.title} target={getTarget(elem.target)}>
                  {`${elem.texto1.toLowerCase()} ${elem.texto2.toLowerCase()}`}
                </Link>
              </ListItem>
            )
        )}
      <ListItem key={generate()}>
        <Link href="/landingpage/politica-de-privacidade" title="Política de privacidade" target="_blank">
          Política de privacidade
        </Link>
      </ListItem>
    </ListStyled>
  </Grid>
);

FooterHelpAndSupport.defaultProps = {
  helpSupport: [],
  isRender: false,
};

FooterHelpAndSupport.propTypes = {
  helpSupport: array,
  isRender: bool,
};

export default FooterHelpAndSupport;
